angular.module('dpw.services')

    .run(['$interpolate', function ($interpolate) {
        /**
         * @example
         * var template = 'Hello {{name}}';
         * var context = {name: 'Howie'};
         * var result = RCDPW.textInterpolate(template, context);   // The result is 'Hello Howie'
         *
         * @param {String} template
         * @param {Object} context
         * @param {Object} [options]
         * @param {Boolean} [options.disableEscaping=false]
         * @returns {String}
         *
         * @note Strings inside the context will be escaped by default
         */
        RCDPW.textInterpolate = function (template, context, options) {
            options = options || {};

            var disableEscaping = options.disableEscaping === true;
            if (!disableEscaping) {
                context = _.reduce(context, function (newContext, value, key) {
                    newContext[key] = _.isString(value) ? _.escape(value) : value;
                    return newContext;
                }, {});
            }

            return $interpolate(template)(context);
        };
    }])

;